import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from "react-router-dom";
import { User } from "react-feather";
import Notiflix from "notiflix";
import Footer from "./Components/Footer";

import Contact from "./Components/Contact";
import CustomError404 from "./Components/CustomError404";
import Login from "./Pages/auth/Login";
import Register from "./Pages/auth/Register";
import VerifyMobile from "./Pages/auth/VerifyMobile";
import VerifyEmail from "./Pages/auth/VerifyEmail";
import LoginOtp from "./Pages/auth/LoginOtp";
import MyProfile from "./Pages/Profile/MyProfile";
import PostApiCall from "./Api/Api";
import AddAuditor from "./Pages/Auditor/AddAuditor";
import PublishJobList from "./Pages/Publish/PublishJobList";
import Navbar from "./Components/Navbar";
import AuditorList from "./Pages/Auditor/AuditorList";
import Home from "./Pages/Dashboard/Home";
import ProtectedRoutes from "./Components/ProtectedRoutes";
import JobOpening from "./Pages/Opening/JobOpening";
import Notification from "./Pages/Dashboard/Notification";
import ViewAuditor from "./Pages/Auditor/ViewAuditor";

import { ToastContainer } from "react-toastify";
import ViewPublishJob from "./Pages/Publish/ViewPublishJob";
import JobDetail from "./Pages/Opening/JobDetail";
import ViewApplicantDetails from "./Pages/Profile/ViewApplicantDetails";
import ScrollToTop from "./Helper/ScrollToTop";
import history from "./Helper/History";
import AddNewJob from "./Pages/Publish/AddNewJob";
import { Redirect } from "react-router-dom/cjs/react-router-dom";
import TermsCondition from "./Pages/Dashboard/TermsCondition";
import ReferralLanding from "./Pages/Dashboard/ReferralLanding";
import PrivacyPolicy from "./Pages/Dashboard/PrivacyPolicy";
import AboutUs from "./Pages/Dashboard/AboutUs";
import HomePage from "./Pages/Dashboard/HomePage";

const MainMenu = () => {
  // Mock function to check if the user is logged in
  const isAuthenticated = () => {
    return !!localStorage.getItem("user"); // Example: Check if a token exists
  };
  return (
    <div className="App">
      <ToastContainer />

      <Router history={history}>
        <Navbar />
        <ScrollToTop />
        <Switch>
          {/* <Route exact path="/" component={Home} /> */}
          <Route exact path="/" component={HomePage} />
          <Route exact path="/jobs-opening-list" component={JobOpening} />
          <Route exact path="/terms-condition" component={TermsCondition} />
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route exact path="/refer-earn" component={ReferralLanding} />
          <Route exact path="/About-us" component={AboutUs} />

          <Route exact path="/jobdetails/:id/:name" component={JobDetail} />

          <Route
            exact
            path="/view-applicant-detail"
            component={ViewApplicantDetails}
          />
          <Route exact path="/contactus" component={Contact} />
          {/* <Route exact path="/login" component={Login} /> */}
          {/* <Route exact path="/admin-login" component={Login} /> */}
          <Route
            exact
            path="/login"
            render={(props) =>
              isAuthenticated() ? (
                <Redirect to="/" /> // Redirect to homepage if logged in
              ) : (
                <Login {...props} />
              )
            }
          />

          <Route
            exact
            path="/admin-login"
            render={(props) =>
              isAuthenticated() ? (
                <Redirect to="/" /> // Redirect to homepage if logged in
              ) : (
                <Login {...props} />
              )
            }
          />
          <Route
            exact
            path="/register/:refercode"
            render={({ ...props }) => {
              const { refercode } = props.match.params ?? null; // Extract the params

              return isAuthenticated() ? (
                <Redirect to="/" /> // Redirect to homepage if logged in
              ) : (
                <Register {...props} refercode={refercode} />
              );
            }}
            // component={Register}
          />
          <Route
            exact
            path="/register"
            render={(props) =>
              isAuthenticated() ? (
                <Redirect to="/" /> // Redirect to homepage if logged in 
              ) : (
                <Register {...props} />
              )
            }
            // component={Register}
          />
          <Route
            exact
            path="/verifymobile"
            render={(props) =>
              isAuthenticated() ? (
                <Redirect to="/" /> // Redirect to homepage if logged in
              ) : (
                <VerifyMobile {...props} />
              )
            }
            // component={VerifyMobile}
          />
          <Route
            exact
            path="/verifyemail"
            render={(props) =>
              isAuthenticated() ? (
                <Redirect to="/" /> // Redirect to homepage if logged in
              ) : (
                <VerifyEmail {...props} />
              )
            }
            // component={VerifyEmail}
          />

          <ProtectedRoutes
            requiredRole={["Staff", "Seeker", "Auditor", "Recruiter"]}
            exact
            path="/account"
            component={MyProfile}
          />
          <ProtectedRoutes
            requiredRole={["Staff", "Seeker", "Auditor", "Recruiter"]}
            exact
            path="/notification"
            component={Notification}
          />
          {/* <ProtectedRoutes
            requiredRole={["Staff", "Auditor", "Recruiter","Seeker"]}
            exact
            path="/audits-opening-list"
            component={AuditOpening}
          /> */}
          <ProtectedRoutes
            requiredRole={["Staff"]}
            exact
            path="/add-auditor"
            component={AddAuditor}
          />
          <ProtectedRoutes
            requiredRole={["Staff"]}
            exact
            path="/view-auditor/:id"
            component={ViewAuditor}
          />
          {/* <ProtectedRoutes
            requiredRole={["Staff"]}
            exact
            path="/view-auditor/:id"
            render={(props) => <ViewAuditor {...props} />}
          /> */}
          <ProtectedRoutes
            requiredRole={["Staff", "Seeker", "Auditor", "Recruiter"]}
            exact
            path="/edit/:id"
            component={ViewAuditor}
          />
          <ProtectedRoutes
            requiredRole={["Staff"]}
            exact
            path="/auditor-list"
            component={AuditorList}
          />
          {/* <ProtectedRoutes requiredRole={['Staff','Recruiter']} exact path="/publish-audit" component={PublishAuditList} /> */}

          {/* <ProtectedRoutes
            requiredRole={["Staff", "Recruiter",]}
            exact
            path="/view-publish-audit"
            component={ViewPublishAudit}
          />  */}
          <ProtectedRoutes
            requiredRole={["Staff", "Recruiter"]}
            exact
            path="/publish-job"
            component={PublishJobList}
          />
          <ProtectedRoutes
            requiredRole={["Staff", "Recruiter"]}
            exact
            path="/add-new-job"
            component={AddNewJob}
          />
          <ProtectedRoutes
            requiredRole={["Staff", "Recruiter"]}
            exact
            path="/view-publish-job"
            component={ViewPublishJob}
          />

          <Route component={CustomError404} />
        </Switch>
      </Router>
      <Footer />
    </div>
  );
};

export default MainMenu;
